var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationDocumentGael(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 337,
    viewBox: "0 0 336 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_111903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.986 179.744C236.917 179.744 156.602 99.4329 156.602 0.359375H335.986V179.744Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.368 122.988H224.039C226.332 122.988 227.963 120.761 227.268 118.577L208.017 57.9141H195.234L215.134 120.621C215.579 122.029 216.888 122.984 218.368 122.984V122.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.555 115.348L263.513 26.9844H202.658L231.64 118.304C233.272 123.452 229.428 128.702 224.024 128.702H281.772C288.715 128.702 293.653 121.959 291.555 115.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.746 296.78L178.155 249.527L198.11 234.362L215.283 263.165L240.203 179.58C241.367 175.682 243.424 172.05 248.716 172.259L270.373 172.07C271.767 172.056 272.904 173.179 272.925 174.574C272.939 175.752 272.137 176.784 270.993 177.056L263.135 178.952C258.694 180.409 256.567 181.699 255.584 186.273L232.233 294.876C230.72 301.904 223.664 306.269 216.699 304.484C212.976 303.529 210.089 301.012 208.506 297.832V297.853L208.43 297.679C208.227 297.254 208.039 296.821 207.886 296.368L207.746 296.773V296.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.941 179.937V168.816C142.941 168.816 148.547 168.363 152.201 164.291C155.854 160.219 155.889 154.885 155.889 154.885L158.755 131.841L134.825 122.156L122.512 139.985L124.144 156.307L123.098 179.93H142.941V179.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5707 185.849C99.6176 182.231 104.178 179.93 109.274 179.93H156.276C162.893 179.93 168.603 183.799 171.266 189.398L198.11 234.357L178.155 249.522L172.87 241.162V297.38H102.762C102.762 297.38 103.989 294.898 101.828 293.155C99.6664 291.412 97.4492 293.009 97.4492 293.009L92.6731 296.614V225.209L92.3593 225.348L63.8769 249.138L48.0773 231.805L96.5567 185.849H96.5707Z",
    fill: "#A3C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34413 278.722C6.13898 273.918 6.59915 271.736 10.3015 268.194C14.0109 264.652 48.0922 231.805 48.0922 231.805L63.8917 249.138L34.8376 273.326L83.9375 303.168L92.6879 296.614L97.464 293.009C97.464 293.009 99.7998 291.259 101.843 293.155C103.886 295.052 102.777 297.381 102.777 297.381H172.885V303.53L174.342 320.369H174.14C176.183 343.657 190.595 508.109 191.404 517.48C192.275 527.576 187.855 535.148 183.553 539.366C179.251 543.584 173.003 549.058 173.003 549.058L172.871 548.897L119.455 597.53L117.28 657.424H89.8362L90.1151 624.249L62.9644 648.966L43.8739 627.909L90.4707 582.044L92.674 320.947H92.6391L92.681 311.221C92.681 311.221 89.7595 316.011 86.8938 316.38C84.0351 316.757 80.5001 315.446 80.5001 315.446L9.56943 286.455C9.56943 286.455 4.54228 283.519 5.33714 278.715L5.34413 278.722ZM151.201 522.27C154.317 519 153.474 512.794 153.474 512.794L138.622 332.556L129.098 332.333L121.122 551.875L151.208 522.263L151.201 522.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.613 30.4568L263.511 26.9922H198.201L227.268 118.583C227.959 120.767 226.332 122.993 224.039 122.993H218.368C216.893 122.993 215.583 122.039 215.134 120.631L195.234 57.9239",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.977 112.183L210.948 121.547C212.3 125.809 216.258 128.701 220.73 128.701H281.763C288.706 128.701 293.643 121.958 291.545 115.347L275.486 64.7424C274.257 60.8664 277.147 56.9141 281.212 56.9141H356.906",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.018 57.9141H190.764L200.279 87.8555",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.658 26.9844L231.64 118.304C233.272 123.452 229.428 128.702 224.024 128.702",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.725 37.1322L264.605 30.4531",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7236 311.281C92.1588 376.146 89.7115 672.51 89.7115 672.51L134.454 672.628V668.724C134.454 668.724 128.464 665.928 122.58 662.95C117.19 660.231 117.071 659.22 117.071 652.296L129.05 332.512L138.63 332.568L153.44 514.402C153.718 517.868 152.45 521.27 149.967 523.704L120.836 552.249",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.078 598.293L182.374 540.512C188.789 534.655 192.129 526.149 191.397 517.489L172.871 303.533V297.383",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.988 156.748C129.761 163.525 135.5 168.636 142.319 168.636C149.068 168.636 154.772 163.623 155.629 156.929L158.857 131.779C160.301 120.561 151.557 110.625 140.241 110.625C129.085 110.625 120.391 120.303 121.583 131.403L123.891 152.257C124.114 154.342 124.197 156.441 124.135 158.533L123.068 179.868",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.941 168.812V179.752",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.94 153.068L127.335 149.77C119.645 140.246 128.283 134.215 132.836 142.079C132.836 142.079 138.177 139.521 137.348 127.695C143.379 135.386 153.907 136.801 158.502 133.622",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6768 211.039V296.612",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.913 298.617L172.872 241.164",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.637 189.945L215.292 263.163",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.759 297.388H172.867V196.176C172.867 187.21 165.595 179.938 156.628 179.938H108.763C104.907 179.938 101.197 181.416 98.4085 184.079L80.5041 201.173M92.6771 225.182L34.8268 273.333L83.9267 303.175L97.4253 293.058C98.7919 292.033 100.688 292.124 101.95 293.268C103.303 294.495 103.512 296.552 102.425 298.023L90.9689 313.543C89.2746 315.844 86.4716 317.065 83.6339 316.737L11.9502 287.697C4.23167 284.859 3.41588 275.565 8.72888 269.701L48.1381 232.075C50.748 229.583 48.9843 225.182 45.3758 225.182H-10.9375",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8887 249.145L48.5625 232.234",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.165 249.524L198.121 234.359",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.875 303.531H98.353",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.812 111.922H187.75C185.541 111.922 183.75 113.713 183.75 115.922V161.797V192.359C183.75 194.569 185.541 196.359 187.75 196.359H229.841C232.517 196.359 234.439 198.937 233.674 201.502L207.704 288.597C205.647 295.485 209.733 302.702 216.699 304.487C223.664 306.272 230.72 301.907 232.233 294.879L255.591 186.276C256.574 181.709 258.701 180.412 263.142 178.955L271 177.058C272.144 176.779 272.945 175.754 272.938 174.576H272.931C272.918 173.182 271.774 172.066 270.38 172.073L248.723 172.261C247.188 172.261 243.688 172.297 241.938 175.359",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.728 54.0017C231.685 51.8332 231.194 48.1518 228.631 45.7791C226.069 43.4064 222.405 43.2409 220.448 45.4094C218.491 47.578 218.982 51.2594 221.544 53.6321C224.107 56.0048 227.771 56.1703 229.728 54.0017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.072 49.9639C218.384 46.7615 220.885 44.1576 224.676 44.0933V44.0919L223.428 43.7656C219.557 43.7656 217.625 46.7209 218.322 49.9639C219.019 53.2069 221.84 55.836 225.712 55.836L226.593 55.5098C222.722 55.5098 219.884 53.2069 219.187 49.9639H219.072Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.751 54.0017C231.709 51.8332 231.218 48.1518 228.655 45.7791C226.092 43.4064 222.428 43.2409 220.471 45.4094C218.514 47.578 219.005 51.2594 221.568 53.6321C224.131 56.0048 227.794 56.1703 229.751 54.0017Z",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.307 43.8828H222.81C219.636 43.8828 217.527 46.4886 218.098 49.7029C218.669 52.9172 221.704 55.523 224.878 55.523H225.506",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.007 50.0345L225.875 51.9965L226.178 46.1875",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.904 46.7344H258.904",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.779 51.1094H261.529",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.478 80.2517C240.435 78.0832 239.944 74.4018 237.381 72.0291C234.819 69.6564 231.155 69.4909 229.198 71.6594C227.241 73.828 227.732 77.5094 230.294 79.8821C232.857 82.2548 236.521 82.4203 238.478 80.2517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.822 76.2139C227.134 73.0115 229.635 70.4076 233.426 70.3433V70.3419L232.178 70.0156C228.307 70.0156 226.375 72.9709 227.072 76.2139C227.769 79.4569 230.59 82.086 234.462 82.086L235.343 81.7598C231.472 81.7598 228.634 79.4569 227.937 76.2139H227.822Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.501 80.2517C240.459 78.0832 239.968 74.4018 237.405 72.0291C234.842 69.6564 231.178 69.4909 229.221 71.6594C227.264 73.828 227.755 77.5094 230.318 79.8821C232.881 82.2548 236.544 82.4203 238.501 80.2517Z",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.057 70.1328H231.56C228.386 70.1328 226.277 72.7386 226.848 75.9529C227.419 79.1672 230.454 81.773 233.628 81.773H234.256",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.757 76.2845L234.625 78.2465L234.928 72.4375",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.779 71.2344H266.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.654 75.6094H269.404",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.529 79.9844H263.279",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.228 107.377C249.185 105.208 248.694 101.527 246.131 99.1541C243.569 96.7814 239.905 96.6159 237.948 98.7844C235.991 100.953 236.482 104.634 239.044 107.007C241.607 109.38 245.271 109.545 247.228 107.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.572 103.339C235.884 100.136 238.385 97.5326 242.176 97.4683V97.4669L240.928 97.1406C237.057 97.1406 235.125 100.096 235.822 103.339C236.519 106.582 239.34 109.211 243.212 109.211L244.093 108.885C240.222 108.885 237.384 106.582 236.687 103.339H236.572Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.251 107.377C249.209 105.208 248.718 101.527 246.155 99.1541C243.592 96.7814 239.928 96.6159 237.971 98.7844C236.014 100.953 236.505 104.634 239.068 107.007C241.631 109.38 245.294 109.545 247.251 107.377Z",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.807 97.2578H240.31C237.136 97.2578 235.027 99.8636 235.598 103.078C236.169 106.292 239.204 108.898 242.378 108.898H243.006",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.507 103.41L243.375 105.372L243.678 99.5625",
    stroke: "#F39200",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.529 100.109H277.279",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.404 104.484H271.154",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_111903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    fill: "white",
    transform: "translate(0 0.359375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDocumentGael);
export default __webpack_public_path__ + "static/media/illustration-document-gael.ca9ea019.svg";
export { ForwardRef as ReactComponent };